import { type Pathname } from '@Types/navigation/navigation'

type NextRouteName =
  | 'account'
  | 'accountCompanions'
  | 'accountConsentManagement'
  | 'accountCreation'
  | 'accountCards'
  | 'accountBikeShelters'
  | 'accountBikeSheltersForm'
  | 'accountCRCForm'
  | 'accountDisplaySettings'
  | 'accountInvoiceRequest'
  | 'accountPaymentMethods'
  | 'accountPersonalInfo'
  | 'accountPlaces'
  | 'authenticate'
  | 'cancellationJourneys'
  | 'cancellationJourneysAndPassengers'
  | 'cancellationPassengers'
  | 'cancellationQuotation'
  | 'cancellationQuotationCard'
  | 'cancellationQuotationPass'
  | 'cart'
  | 'catalogOfferWishes'
  | 'catalogue'
  | 'catalogueDescription'
  | 'cataloguePricingOffers'
  | 'confirmation'
  | 'confirmationCancellationFinalization'
  | 'confirmationCardCancellationFinalization'
  | 'confirmationExchange'
  | 'consultationTripDetail'
  | 'consultationTripDetailTicketing'
  | 'consultationTripSearch'
  | 'consultationTripSearchFindReference'
  | 'consultationTripSearchResults'
  | 'contactInformation'
  | 'exchangeBooking'
  | 'exchangeBookingPayment'
  | 'exchangeItineraryOutward'
  | 'exchangeJourneysAndTravelers'
  | 'exchangePayment'
  | 'exchangeStep1'
  | 'exchangeStep2'
  | 'exchangeStep3'
  | 'exchangeValidation'
  | 'itineraries'
  | 'logout'
  | 'payment'
  | 'paymentValidation'
  | 'redirect'
  | 'stationTimetableResults'
  | 'stationTimetableSearch'
  | 'ticketsConsultation'
  | 'ticketDetails'
  | 'ticketsHistory'
  | 'trafficInfo'

export const NEXT_ROUTES = {
  account: '/account',
  accountBikeShelters: '/account/bike-shelters',
  accountBikeSheltersForm: '/account/bike-shelters/form',
  accountCards: '/account/cards',
  accountCompanions: '/account/companions',
  accountConsentManagement: '/account/consent-management',
  accountCRCForm: '/account/crc-form',
  accountCreation: '/accounts/registration-redirect',
  accountDisplaySettings: '/account/display-settings',
  accountInvoiceRequest: '/account/invoice-request',
  accountPaymentMethods: '/account/payment-methods',
  accountPersonalInfo: '/account/personal-info',
  accountPlaces: '/account/places',
  authenticate: '/authenticate',
  cancellationJourneys: '/cancellation/journeys',
  cancellationJourneysAndPassengers: '/cancellation/journeys-and-travelers',
  cancellationPassengers: '/cancellation/passengers',
  cancellationQuotation: '/cancellation/quotation',
  cancellationQuotationCard: '/cancellation/quotationCard',
  cancellationQuotationPass: '/cancellation/quotationPass',
  cart: '/cart',
  catalogOfferWishes: '/catalogue/offer/wishes',
  catalogue: '/catalogue',
  catalogueDescription: '/catalogue/description',
  cataloguePricingOffers: '/catalogue/pricing',
  confirmation: '/confirmation',
  confirmationCancellationFinalization: '/confirmation/cancellation/finalization',
  confirmationCardCancellationFinalization: '/confirmation/cancellation/finalization/card',
  confirmationExchange: '/confirmation/exchange',
  consultationTripDetail: '/trips/detail',
  consultationTripDetailTicketing: '/trips/detail/ticketing',
  consultationTripSearch: '/trips/search',
  consultationTripSearchFindReference: '/trips/search/find-reference',
  consultationTripSearchResults: '/trips/search/results',
  contactInformation: '/contact/information',
  exchangeBooking: '/exchange/booking',
  exchangeBookingPayment: '/exchange/bookingPayment',
  exchangeItineraryOutward: '/exchange/search/outward',
  exchangeJourneysAndTravelers: '/exchange/journeys-and-travelers',
  exchangePayment: '/exchange/payment',
  exchangeStep1: '/exchange/step1',
  exchangeStep2: '/exchange/step2',
  exchangeStep3: '/exchange/step3',
  exchangeValidation: '/exchange/validation',
  itineraries: '/itineraries',
  logout: '/logout',
  payment: '/payment',
  paymentValidation: '/payment/validation',
  redirect: '/redirect',
  stationTimetableResults: '/station-timetable/results',
  stationTimetableSearch: '/station-timetable',
  ticketsConsultation: '/tickets',
  ticketDetails: '/tickets/ticket-details',
  ticketsHistory: '/tickets/history',
  trafficInfo: '/traffic-info',
} satisfies Record<NextRouteName, Pathname>

export const HOME_PATH = '/'
